<template>
  <v-hover>
    <base-card
      slot-scope="{ hover }"
      color="accent"
      class="elevation-0"
      :class="{'elevation-12 scale-down' : hover}"
      :to="to"
    >
      <tk-media
        :height="$vuetify.breakpoint.smAndUp ? '295px' : '180px'"
        class="accent-base lighten-2"
        sizes="600px"
        :media="src"
      />
      <v-card-title primary-title class="card-title">
        <v-container px-0 py-0>
          <v-layout row>
            <v-flex pb-0 class="ellipis" shrink text-xs-left>
              <router-link
                class="artwork-title ellipis font-weight-bold"
                :to="to"
              >{{ title }}</router-link>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex pt-0 class="ellipis" text-xs-left>
              <div class="font-weight-light ellipis artwork-subtitle">{{ count }} {{$tc('ARTWORK.COUNT', count)}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
    </base-card>
  </v-hover>
</template>

<script>
import { Artwork } from "@/services/artwork/Artwork";
export default {
  props: ["height", "src", "title", "to", "titleI18n", "aspectRatio", "count"],
};
</script>

<style lang="scss" scoped>
.horizontal-scroll {
  @media (max-width: 960px) {
    overflow-x: scroll;
  }
}

.artwork-title {
  font-size: 16px;
  text-decoration: none;
  line-height: 23px;
}
.artwork-subtitle {
  font-size: 12px;
  text-decoration: none;
  line-height: 18px;
}
.card-title{
  padding: 22px;
}

@media (min-width: 960px) {
  .title {
    font-size: 16px !important;
  }
  .artwork-title {
    font-size: 16px !important;
    &-icon {
      font-size: 12px !important;
      position: relative;
      top: -2px;
    }
  }
  .artwork-dimension {
    font-size: 10px !important;
  }
}
</style>
